var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-primary button-primary-lf mt-4 p-2",staticStyle:{"border":"none"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('nuevo')}}},[_c('span',{staticClass:"cta-small m-2",staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }